<h2>Select a duration</h2>

<div class="flex justify-content-center">
  <div class="flex flex-column gap-3">
    @for (duration of durations; track $index) {
    <div class="field-checkbox">
      <p-radioButton [inputId]="duration.id" name="category" [value]="duration.minutes" [(ngModel)]="selectedDuration" (onClick)="onDurationClick()" />
      <label [for]="duration.id" class="ml-2">
        {{ duration.minutes }} Minutes
      </label>
    </div>
    }
  </div>
</div>
<div class="flex justify-content-between mt-1 w-full">
  <p-button routerLink="../" label="BACK"></p-button>
  <p-button [routerLink]="['../', routes.SELECT_STATION]" [disabled]="!selectedDuration" label="NEXT"></p-button>
</div>